<!--
  - Copyright (c) 2025. Haodong JU
  -->

<template>
  <div class="member-selector-example">
    <h2 class="mb-4">会员选择器示例</h2>

    <v-card class="mb-6">
      <v-card-title>对话框选择器</v-card-title>
      <v-card-text>
        <p>通过对话框选择会员，返回会员ID列表</p>
        <v-btn
          color="primary"
          @click="openDialog"
        >
          打开会员选择器
        </v-btn>

        <div v-if="selectedMemberIds.length > 0" class="mt-4">
          <h3>已选择的会员ID:</h3>
          <pre>{{ selectedMemberIds }}</pre>
        </div>
      </v-card-text>
    </v-card>

    <v-card class="mb-6">
      <v-card-title>全局对话框选择器</v-card-title>
      <v-card-text>
        <p>通过全局对话框选择会员，可以在任何组件中使用</p>
        <v-btn
          color="success"
          @click="openGlobalDialog"
        >
          打开全局会员选择器
        </v-btn>

        <div v-if="globalSelectedMemberIds.length > 0" class="mt-4">
          <h3>已选择的会员ID:</h3>
          <pre>{{ globalSelectedMemberIds }}</pre>
        </div>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title>内嵌选择器</v-card-title>
      <v-card-text>
        <p>直接在页面中嵌入会员选择器</p>
        <member-selector
          v-model="inlineSelectedMemberIds"
          return-mode="user"
          @selection-confirmed="onInlineSelectionConfirmed"
        ></member-selector>

        <div v-if="inlineSelectedMemberIds.length > 0" class="mt-4">
          <h3>已选择的会员ID:</h3>
          <pre>{{ inlineSelectedMemberIds }}</pre>
        </div>
      </v-card-text>
    </v-card>

    <!-- Member Selector Dialog -->
    <member-selector-dialog
      ref="memberSelectorDialog"
      title="选择会员"
      :multiple="true"
      :initial-selection="selectedMemberIds"
      return-mode="user"
    ></member-selector-dialog>
  </div>
</template>

<script>
import { MemberSelector, MemberSelectorDialog, openMemberSelectorDialog } from './index'

export default {
  name: 'MemberSelectorExample',
  components: {
    MemberSelector,
    MemberSelectorDialog
  },
  data () {
    return {
      selectedMemberIds: [],
      inlineSelectedMemberIds: [],
      globalSelectedMemberIds: []
    }
  },
  methods: {
    /**
     * Open the member selector dialog
     */
    async openDialog () {
      try {
        // Open the dialog and wait for user selection
        const selectedIds = await this.$refs.memberSelectorDialog.open()

        // Update the selected member IDs
        this.selectedMemberIds = selectedIds

        // Show success message
        this.$toast.success(`已选择 ${selectedIds.length} 位会员`)
      } catch (error) {
        // User cancelled the selection
        console.log('Selection cancelled:', error)
      }
    },

    /**
     * Open the global member selector dialog
     */
    async openGlobalDialog () {
      try {
        // Open the global dialog and wait for user selection
        const selectedIds = await openMemberSelectorDialog({
          title: '全局会员选择器',
          multiple: true,
          initialSelection: this.globalSelectedMemberIds,
          returnMode: 'membership' // 'membership' or 'user'
        })

        // Update the selected member IDs
        this.globalSelectedMemberIds = selectedIds

        // Show success message
        this.$toast.success(`已选择 ${selectedIds.length} 位会员`)
      } catch (error) {
        // User cancelled the selection
        console.log('Selection cancelled:', error)
      }
    },

    /**
     * Handle selection confirmed from inline selector
     */
    onInlineSelectionConfirmed (selectedIds) {
      this.$toast.success(`已选择 ${selectedIds.length} 位会员`)
    }
  }
}
</script>

<style scoped>
.member-selector-example {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

pre {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
}
</style>
